// extracted by mini-css-extract-plugin
export default {"FakeLink":"FakeLink_FakeLink__R8dEd"};